/* GENERATED by scripts/gen-data.mjs — chapter "x-cost" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_COST: NodeDef = {
  "id": "x-cost",
  "tagKey": "path:x-cost.tag",
  "x": 376,
  "y": 700,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-cost.title",
  "subKey": "path:x-cost.sub",
  "blocks": [
    {
      "id": "x-cost.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-cost.b1.title",
      "bodyKey": "path:x-cost.b1.body",
      "flowKey": "path:x-cost.b1.flow",
      "read": [
        "infer",
        "gptq"
      ]
    },
    {
      "id": "x-cost.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:x-cost.b2.title",
      "film": "f-cost"
    },
    {
      "id": "x-cost.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-cost.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-cost.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-cost.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-cost.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-cost.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-cost.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-cost.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-cost.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-cost.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "production"
};
